import type { ToolDefinition } from "../types";
import imageCropperTool from "./image-cropper";
import imageResizerTool from "./image-resizer";
import imageDpiChangerTool from "./image-dpi-changer";
import imageWatermarkTool from "./image-watermark";
import imageColorEffectsTool from "./image-color-effects";
import imageSharpenTool from "./image-sharpen";
import convertImageToPureBlackAndWhiteOnlineTool from "./convert-image-to-pure-black-and-white-online";

export const editingTools: ToolDefinition[] = [
  imageCropperTool,
  imageResizerTool,
  imageDpiChangerTool,
  imageWatermarkTool,
  imageColorEffectsTool,
  imageSharpenTool,
  convertImageToPureBlackAndWhiteOnlineTool,
];

export { default as imageCropperTool } from "./image-cropper";
export { default as imageResizerTool } from "./image-resizer";
export { default as imageDpiChangerTool } from "./image-dpi-changer";
export { default as imageWatermarkTool } from "./image-watermark";
export { default as imageColorEffectsTool } from "./image-color-effects";
export { default as imageSharpenTool } from "./image-sharpen";
export { default as convertImageToPureBlackAndWhiteOnlineTool } from "./convert-image-to-pure-black-and-white-online";
